module.exports = __webpack_public_path__ + "static/media/img-feature-slider-4@2x.7538682f.png";